var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPharmacyCrossIcon = function SvgPharmacyCrossIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2736 29.75C20.8535 29.75 21.3236 29.2799 21.3236 28.7V21.3204H28.7C29.2799 21.3204 29.75 20.8503 29.75 20.2704V10.7264C29.75 10.1465 29.2799 9.67638 28.7 9.67638H21.3236V2.3C21.3236 1.7201 20.8535 1.25 20.2736 1.25H10.7264C10.1465 1.25 9.67638 1.7201 9.67638 2.3V9.67638H2.3C1.7201 9.67638 1.25 10.1465 1.25 10.7264V20.2736C1.25 20.8535 1.7201 21.3236 2.3 21.3236H9.67638V28.7C9.67638 29.2799 10.1465 29.75 10.7264 29.75H20.2736Z",
    stroke: "#013A63",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPharmacyCrossIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pharmacy_cross_icon.a52fdb5b.svg";
export { ForwardRef as ReactComponent };